import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import { UserIcon } from '../../assets/icons/icons';
import './style.css';
import ProfileModal from '../ProfileModal/ProfileModal';

function getOrdinalSuffix(day) {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

function formatLongDate(date) {
  const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'long' });
  const month = date.toLocaleDateString('en-US', { month: 'long' });
  const day = date.getDate();
  const suffix = getOrdinalSuffix(day);
  return `${dayOfWeek}, ${month} ${day}${suffix}`;
}

function getFirstName(value) {
  if (!value || typeof value !== 'string') return '';
  const trimmed = value.trim();
  if (!trimmed) return '';
  return trimmed.split(/\s+/)[0];
}

export default function HeaderSection() {
  const [displayName, setDisplayName] = useState('');
  const [email, setEmail] = useState('');
  const [showProfile, setShowProfile] = useState(false);

  useEffect(() => {
    const loadUser = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return;
      const user = session.user;
      const meta = user.user_metadata || {};
      const fallbackFromMeta = getFirstName(meta.first_name || meta.full_name || meta.name);
      const emailFallback = user.email ? user.email.split('@')[0] : 'there';
      let resolvedName = '';

      if (user?.id) {
        try {
          const { data, error } = await supabase
            .from('assessments')
            .select('name')
            .eq('user_id', user.id)
            .maybeSingle();
          if (!error && data?.name) {
            resolvedName = getFirstName(data.name);
          }
        } catch (err) {
        }
      }

      if (!resolvedName && typeof window !== 'undefined') {
        try {
          const local = localStorage.getItem('onboarding_profile');
          if (local) {
            const parsed = JSON.parse(local);
            const storedName = parsed?.basics?.name || parsed?.name;
            resolvedName = getFirstName(storedName);
          }
        } catch (err) {
        }
      }

      const fallbackName = fallbackFromMeta || emailFallback || 'there';
      setDisplayName(resolvedName || fallbackName);
      setEmail(user.email || '');
    };
    loadUser();
  }, []);

  const handleLogout = async () => {
    try {
      await supabase.auth.signOut();
    } catch (_) {}
    try {
      localStorage.removeItem('payment_complete');
      localStorage.removeItem('payment_session_id');
      localStorage.removeItem('selected_plan_id');
      localStorage.removeItem('selected_plan_name');
      localStorage.removeItem('onboarding_profile');
    } catch (_) {}
    window.location.href = '/login';
  };

  const today = formatLongDate(new Date());

  return (
    <div className="header-section">
      <div className="header-text">
        <h2>Hi, <span className='header-name'>{displayName}</span></h2>
        <p className="header-date">{today}</p>
      </div>
      <div className="profile">
        <UserIcon className="profile-icon" onClick={() => setShowProfile(true)} />
      </div>
      {showProfile && (
        <ProfileModal onClose={() => setShowProfile(false)} />
      )}
    </div>
  );
}
